import { getGlobalHeadersAsObject } from "./global-headers";

export interface LicKeysMatrixResponse {
	columns: string[];
	rows: Array<Record<string, string | number | null>>;
}

export async function getLicKeysMatrix(
	mode?: "working" | "alive" | "maintenance" | "has_session"
): Promise<LicKeysMatrixResponse> {
	const qs = mode ? `?active_definition=${encodeURIComponent(mode)}` : "";
	const response = await fetch(`/api/v2/lic-keys/${qs}`, {
		method: "GET",
		headers: {
			"Content-Type": "application/json",
			...getGlobalHeadersAsObject(),
		},
	});

	if (!response.ok) {
		throw new Error(`Failed to fetch lic-key matrix: ${response.status}`);
	}

	return response.json();
}
